import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IcontestDataResponse } from 'app/features/contest/models/contest-api.models';
import { IUserInfo } from 'app/features/contest/models/contest-user-info.models';
import { Observable } from 'rxjs';
import { APP_TOKEN, environment } from 'src/environments/environment';
import { ContestApi, ContestDataQuery, DeleteActivityResponse } from './contest-api.types';

@Injectable({ providedIn: 'root' })
export class ContestApiService implements ContestApi {
  private readonly http: HttpClient = inject(HttpClient);

  deleteActivity(activityId: number): Observable<DeleteActivityResponse> {
    const userAccessToken: string | null = localStorage.getItem('user_access_token');

    if (!userAccessToken) throw new Error('no token');

    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${userAccessToken}`,
    });

    return this.http.delete<DeleteActivityResponse>(
      environment.api.contest.deleteActivity.replace(':id', activityId.toString()),
      { headers, responseType: 'json' }
    );
  }

  getContestData(query: ContestDataQuery): Observable<IcontestDataResponse> {
    const params: HttpParams = new HttpParams()
      .set('appToken', APP_TOKEN)
      .set('filter', query.pprFilter)
      .set('displayMode', query.targetGender)
      .set('contestDataMode', query.mode)
      .set('page', query.page + 1)
      .set('limit', environment.contestInfo.userPerPage);

    return this.http.get<IcontestDataResponse>(
      environment.api.contest.infos
        .replace(':username', query.username.toLowerCase())
        .replace(':hashid', query.hashid),
      { params, responseType: 'json' }
    );
  }

  getUserInfo(username: string, hashid: string): Observable<IUserInfo> {
    const params: HttpParams = new HttpParams().set('appToken', APP_TOKEN);

    return this.http.get<IUserInfo>(
      environment.api.contest.user
        .replace(':username', username.toLowerCase())
        .replace(':hashid', hashid),
      { params, responseType: 'json' }
    );
  }

  exportData(
    contestUsername: string,
    hashId: string,
    pprFilter: number,
    email: string
  ): Observable<unknown> {
    const userAccessToken: string | null = localStorage.getItem('user_access_token');

    if (!userAccessToken) throw new Error('no token');

    const params: HttpParams = new HttpParams()
      .set('filter', pprFilter.toString())
      .set('email', email);
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${userAccessToken}`,
    });

    return this.http.get(
      environment.api.contest.export
        .replace(':username', contestUsername.toLowerCase())
        .replace(':hashid', hashId),
      { headers, params }
    );
  }

  resetData(contestUsername: string, hashId: string): Observable<unknown> {
    const userAccessToken: string | null = localStorage.getItem('user_access_token');
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: `Bearer ${userAccessToken}`,
    });

    return this.http.post(
      environment.api.contest.reset
        .replace(':username', contestUsername.toLowerCase())
        .replace(':hashid', hashId),
      {},
      { headers }
    );
  }
}
